function getAttributeValue(character: any, attributeName: string): string | undefined {
  const attribute = character.find((attr: any) => attr.name === attributeName);

  return attribute ? attribute.value : undefined;
}

export default getAttributeValue;
